<template>
    <div class="page">
        <ion-grid>
            <ion-row  align-items-stretch>
                <ion-col size="12" size-md="12" v-for="item in notificationDetails" :key="item">
                    <ion-card @click= "openNotificationDetailsPage(item)" >
                        <ion-card-content class="vh-content">
                            <ion-row>
                                <ion-col text-left size="6">
                                <ion-label class="book-ref">{{item.notificationType}}</ion-label>
                                </ion-col>
                                <ion-col text-right size="6">
                                <ion-label class="book-day">
                                    {{changeDateFormat(item.createdOn)}}
                                </ion-label>
                                </ion-col>
                            </ion-row>
                            <hr />
                            <ion-row>
                                <ion-col text-left size="12">
                                <ion-lable class="book-location">{{item.message}}</ion-lable>
                                </ion-col>
                            </ion-row>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div> 
</template>

<script>
import { defineComponent } from "vue";
import { Notifications } from '../../service/notifications/notifications.service';
import { LocalStorage } from "../../data/localstorage";
import { migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";
import moment from "moment";

export default defineComponent ({
  name: 'notificationDetails',
  data() {
    return {
      notificationDetails: "",
      loaderTab: true,
      notificationData: ""
    }
  },
  async mounted() {
    try {
      this.notificationData = JSON.parse(localStorage.getItem("notificationDetails"))
      if(this.notificationData.userId && this.notificationData.id) {
        this.notificationDetails = await new Notifications().getNotificationById(this.notificationData.userId, this.notificationData.id);
        let count = await new Notifications().getunreadNotificationsCount(this.notificationData.userId);
        this.$root.$emit('update-count', count)
        this.loaderTab = false;
      }
    } catch (error) {
      this.loaderTab = false;
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
    
  },
  methods: {
    changeDateFormat(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY HH:mm')
    },
  }
})
</script>

<style scoped>
ion-card {
  /* height: 84px; */
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 16px;
  opacity: 1;
  cursor: pointer;
}

.book-ref {
  text-align: right;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #041648;
  opacity: 1;
}

.book-day {
  text-align: right;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #000000;
  opacity: 1;
}

.book-location {
  text-align: left;
  font-family: "Roboto";
  font-size: 15px;
  letter-spacing: 0;
  color: #414141;
  opacity: 1;
}

.book-amount {
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 15px;
  color: #21b24b;
  opacity: 1;
}

.vh-content {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 16px;
  opacity: 1;
}
.unavailable {
  background: #e27b7b 0% 0% no-repeat padding-box;
}
</style>